import type { StepStatus } from '../ui-model/types'

export function lessonStatusToStep(beStatus: string): 'done' | 'locked' {
  return beStatus === 'completed' ? 'done' : 'locked'
}

export interface HasBeStatus { status: string }

export function componentListToStepStatus<T extends HasBeStatus>(
  items: T[],
): StepStatus[] {
  const result: StepStatus[] = items.map(() => 'locked')
  let currentAssigned = false

  for (let i = 0; i < items.length; i++) {
    if (items[i].status === 'completed' || items[i].status === 'skipped') {
      result[i] = 'done'
    }
  }
  for (let i = 0; i < items.length; i++) {
    if (!currentAssigned && items[i].status === 'in_progress') {
      result[i] = 'current'
      currentAssigned = true
    }
  }
  if (!currentAssigned) {
    for (let i = 0; i < items.length; i++) {
      if (result[i] === 'locked' && items[i].status === 'not_started') {
        result[i] = 'current'
        currentAssigned = true
        break
      }
    }
  }
  return result
}
